import { IReducerAction } from 'src/interfaces/redux';
import { IMarker } from 'src/interfaces/Marker';
import { MARKER_STATUS } from 'src/interfaces/enums';
export * from './marker.selectors';

export interface IMarkerState {
  markers: IMarker[];
  currentMarker: IMarker | null;
  status: string;
  selectedMarkerId: number | null;
  isMarkerOverlayVisible: boolean;
  isMarkerPreviewEnabled: boolean;
}

export const markerInitialState: IMarkerState = {
  markers: [],
  currentMarker: null,
  status: MARKER_STATUS.CLOSED,
  selectedMarkerId: null,
  isMarkerOverlayVisible: false,
  isMarkerPreviewEnabled: false,
};

export enum MarkerActionTypes {
  SET_MARKERS = 'MARKER/SET_MARKERS',
  ADD_MARKER = 'MARKER/ADD_MARKER',
  UPDATE_MARKER = 'MARKER/UPDATE_MARKER',
  REMOVE_MARKER = 'MARKER/REMOVE_MARKER',
  SET_CURRENT_MARKER = 'MARKER/SET_CURRENT_MARKER',
  UPDATE_STATUS = 'MARKER/UPDATE_STATUS',
  SET_SELECTED_MARKER_ID = 'MARKER/SET_SELECTED_MARKER_ID',
  SHOW_MARKER_OVERLAY = 'MARKER/SHOW_MARKER_OVERLAY',
  HIDE_MARKER_OVERLAY = 'MARKER/HIDE_MARKER_OVERLAY',
  SET_MARKER_PREVIEW = 'MARKER/SET_MARKER_PREVIEW',
}

export type IMarkerAction = IReducerAction<MarkerActionTypes>;

export default function markerReducer(state: IMarkerState = markerInitialState, action: IMarkerAction) {
  switch (action.type) {
    case MarkerActionTypes.SET_MARKERS:
      return { ...state, markers: action.payload };
    case MarkerActionTypes.SET_CURRENT_MARKER:
      return { ...state, currentMarker: action.payload };
    case MarkerActionTypes.UPDATE_STATUS:
      return { ...state, status: action.payload };
    case MarkerActionTypes.ADD_MARKER:
      return { ...state, markers: [...state.markers, action.payload] };
    case MarkerActionTypes.UPDATE_MARKER:
      return {
        ...state,
        markers: state.markers.map((marker) => {
          if (marker.id === action.payload.id) return { ...marker, ...action.payload };
          return marker;
        }),
      };
    case MarkerActionTypes.REMOVE_MARKER:
      return {
        ...state,
        markers: state.markers.filter((marker) => marker.id !== action.payload),
      };
    case MarkerActionTypes.SET_SELECTED_MARKER_ID:
      return { ...state, selectedMarkerId: action.payload };
    case MarkerActionTypes.SHOW_MARKER_OVERLAY:
      return { ...state, isMarkerOverlayVisible: true };
    case MarkerActionTypes.HIDE_MARKER_OVERLAY:
      return { ...state, isMarkerOverlayVisible: false };
    case MarkerActionTypes.SET_MARKER_PREVIEW:
      return { ...state, isMarkerPreviewEnabled: action.payload };
    default:
      return state;
  }
}
